<template>
    <div class="tab-member">
        <div class="filter-member">
            <div class="display-flex justify-content-between">
                <div class="wrap-left display-flex">
                    <div class="item item__key input-custom-icon mr-3">
                        <input v-model="keyword" v-debounce="300" type="text" placeholder="Tìm kiếm"
                            class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width">
                        <i class="icon-search font-size-16 primary-color"></i>
                    </div>
                    <a href="javascript:;" @click="toggleCollapseGroup"
                        class="btn-collapse btn border-rd-20 font-size-15 filter-btn"
                        :class="{ 'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }">
                        Bộ lọc <i class="icon-arrow-down font-size-12"
                            :class="{ 'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
                    </a>
                </div>

                <div class="wrap-right display-flex">
                    <!-- <a href="javascript:;" class="item btn btn-group border-rd-20 font-size-16 display-flex-center item__add"
                    >
                    Tạo nhóm
                </a> -->
                <a @click="handleAddGroup" href="javascript:;" class="item btn btn-main btn-group border-rd-20 font-size-16 display-flex-center item__add margin-left-10 margin-right-10"
                    >
                    Tạo nhóm
                </a>
                    <a @click="handleAddMember" href="javascript:;"
                        class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add">
                        <img class="icon-plus" width="20" style="top: 0;" src="@/assets/img/plus.png" />
                        <img class="icon-plus" width="20" style="top: 0;" src="@/assets/img/plus-hover.png" />
                        Thêm học sinh
                    </a>
                </div>
            </div>
            <b-collapse id="collapse_filter" class="mt-2" :visible="openCollapseFilterGroup">
                <div class="row">
                    <div class="col-md-3">
                        <label for="name">Giới tính:</label>
                        <b-form-select v-model="gender" :options="listGender"></b-form-select>
                    </div>
                    <!-- <div class="col-md-12">
                        <div class="filter__section__form text-align-right">
                            <a @click="onRefresh" href="javascript:;" class="primary-color font-sanpro-semibold ">Làm
                                mới</a>
                            <a @click="handleOnFilter" href="javascript:;"
                                class="btn btn-main border-rd-20 btn-submit font-sanpro-semibold margin-left-10 min-width-100">Lọc</a>
                        </div>
                    </div> -->
                </div>
            </b-collapse>
        </div>
        <div class="row">
            <div class="col-md-6">
                <TableMember ref="TableMember" @handleAddMember="handleAddMember"/>
            </div>
        </div>

        <ModalCreateUpdateGroupClassSchool v-if="isModalCreateUpdateGroupClassSchool" :classSchoolId="classSchoolId" :classSchoolGroupId="0" @closeModal="closeModalGroup" @handleDone="closeModalGroup" />

        <ModalAddMemberClassSchool v-if="isShowModalAddMemberClassSchool" :classSchoolId="classSchoolId"
            @handleDone="handleDoneAddMember" @closeModal="closeModalAddMember" />
    </div>
</template>

<script>
import ModalAddMemberClassSchool from './../../_components/ModalAddMemberClassSchool.vue';
import ModalCreateUpdateGroupClassSchool from './../../_components/ModalCreateUpdateGroupClassSchool'
import debounce from "@/directives/debounce";
import TableMember from './TableMember.vue'
export default {
    directives: { debounce },
    components: {
        ModalAddMemberClassSchool,
        TableMember,
        ModalCreateUpdateGroupClassSchool
    },
    data() {
        return {
            classSchoolId: 0,
            keyword: '',
            gender: 0,
            isModalCreateUpdateGroupClassSchool:false,
            openCollapseFilterGroup: false,
            isShowModalAddMemberClassSchool: false, // biến ẩn hiện modal thêm thành viên
            listGender: [
                { value: '0', text: 'Tất cả' },
                { value: '1', text: 'Nam' },
                { value: '2', text: 'Nữ' },
            ]
        }
    },
    watch:{
        keyword(){
            this.getMemberInClassSchool()
        },
        gender(){
            this.getMemberInClassSchool()
        }
    },
    mounted() {
        this.classSchoolId = this.$route.query.id
    },
    methods: {
        closeModalGroup(){
            this.isModalCreateUpdateGroupClassSchool = false
        },
        handleAddGroup(){
            this.isModalCreateUpdateGroupClassSchool = true
        },
        onRefresh() {
            this.gender  = 0
            
        },
        handleOnFilter() {
            this.getMemberInClassSchool()
        },
        toggleCollapseGroup() {
            this.openCollapseFilterGroup = !this.openCollapseFilterGroup
        },
        openModalAddMember() {
            this.isShowModalAddMemberClassSchool = true
        },
        handleAddMember() {
            this.openModalAddMember()
        },
        getMemberInClassSchool(){
            this.$refs.TableMember.getAllMemberInClassSchool({keyword:this.keyword,gender:this.gender})
        },
        handleDoneAddMember() {
            this.getMemberInClassSchool()
            //this.closeModalAddMember()
        },
        closeModalAddMember() {
            this.isShowModalAddMemberClassSchool = false
        },
    }
}
</script>

<style lang="scss" scoped>
.margin-right-10{
    margin-right: 10px;
}
.tab-member {
    margin-top: 20px;

    .filter-member {
        margin-bottom: 20px;
    }
}

.item__show_group {
    margin-right: 10px;
}

// .btn-group{
//     background: #4eec43;
//     color: white;
// }
.btn-edit {
    color: #8ba3f9;
    cursor: pointer;
}

.btn-delete {
    color: red;
    cursor: pointer;
}

.col-table {
    font-size: 14px;
}

// .text-btn-add-member{
//     font-size: 12px;
//     color: #4eec43;
// }
.justify-content-between {
    justify-content: space-between;
}

.filter-Member {
    margin: 10px 0px 10px 0px;
}
.text-align-right{
        text-align: right;
    }
    .margin-left-10{
        margin-left: 10px;
    }
.filter__section__form{
    margin-top: 20px;
    
    .margin-left-10{
        margin-left: 10px;
    }
    .min-width-100{
        min-width: 100px;
    }
}

</style>